export default "__VITE_ASSET__DpTRkZP1__"